import {Box, Stack, Typography} from "@mui/material";
import {STYLE} from "./STYLES";
import {BORDER_RADIUS_OUTER} from "../../config/themes/theme";
export default function FirstSection() {
  return (
    <Box>
      <Stack direction="column" spacing={2} sx={{textAlign: "center"}}>
        <Typography sx={STYLE.sectionTitle}>Ask, Ask, Ask</Typography>
        <Typography sx={STYLE.sectionSubtitle}>
          We&apos;re here to help you get the best possible score on your exam.
        </Typography>
        <Box height={8} />
        <Box
          sx={{
            width: "100%",
            height: "70vh",
            background:
              "linear-gradient(262deg, #F2D3F9 0%, #F1DFF7 23.14%, #F1E6DB 46.76%, #F1ECE5 71.35%, #DCF4EB 100.27%)",
            backgroundImage: "url(/landing/bg-gradient.png)",
            backgroundSize: "cover",
            backgroundPositionX: "center",
            backgroundPositionY: "top",
            backgroundRepeat: "no-repeat",
            borderRadius: BORDER_RADIUS_OUTER,
          }}
        />
      </Stack>
    </Box>
  );
}
